'use client';

import type { Language } from '@app/lib/store-context/Context';
import {
    HomepageVariant,
    NavigationVariant,
} from '@app/lib/experiments/homepage-ab-test';
import PrismicExperimentTracking from '@app/components/prismic-experiment-tracking/prismic-experiment-tracking';

interface HomepageExperimentTrackingProps {
    homepageVariant: HomepageVariant;
    navVariant: NavigationVariant;
    navMenuId: string;
    locale: Language;
}

/**
 * Fires Prismic experiment impressions for the homepage + navigation A/B test.
 *
 * This is a thin wrapper over the generic `PrismicExperimentTracking` so all
 * Prismic experiment analytics flow through a single
 * `prismic_experiment_impression` event. The homepage and navigation are
 * modelled as two separate experiments.
 */
export default function HomepageExperimentTracking({
    homepageVariant,
    navVariant,
    navMenuId,
    locale,
}: HomepageExperimentTrackingProps) {
    return (
        <>
            <PrismicExperimentTracking
                experimentName="homepage_ab_test"
                componentName="homepage"
                variationName={homepageVariant}
                variationId={`homepage-${homepageVariant}`}
                locale={locale}
            />
            <PrismicExperimentTracking
                experimentName="navigation_ab_test"
                componentName="navigation"
                variationName={navVariant}
                variationId={navMenuId}
                locale={locale}
            />
        </>
    );
}
